import type { FormEventHandler, ReactNode } from "react";
import { cn } from "@/shared/utils/cn";
import { Page, PageContent, PageFooter } from "./Page";

interface FormPageProps {
  header: ReactNode;
  children: ReactNode;
  actions: ReactNode;
  onSubmit: FormEventHandler<HTMLFormElement>;
  narrow?: boolean;
  padded?: boolean;
  scrollable?: boolean;
  contentClassName?: string;
}

export function FormPage({
  header,
  children,
  actions,
  onSubmit,
  narrow = false,
  padded = true,
  scrollable = true,
  contentClassName,
}: FormPageProps) {
  return (
    <Page>
      {header}
      <form onSubmit={onSubmit} className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <PageContent padded={padded} className={cn("relative", !scrollable && "overflow-y-hidden [scrollbar-gutter:auto]")}>
          <div className={cn("space-y-[26px]", narrow && "mx-auto w-full max-w-md", contentClassName)}>
            {children}
          </div>
        </PageContent>
        {/* Reserve the same scrollbar gutter as the content so narrow actions stay aligned with the form column. */}
        <PageFooter narrow={narrow} className={cn(narrow && scrollable && "overflow-y-hidden [scrollbar-gutter:stable]")}>{actions}</PageFooter>
      </form>
    </Page>
  );
}
